import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useEffect, type ReactNode } from 'react';
import logo from '../../assets/infinity-ev-black.png';
import pulsepointLogo from '../../assets/pulsepoint-logo.png';

/**
 * Sign-in, forgot and reset password: one column on white, the Pulsepoint logo, the
 * headline, the form, and the Infinity EV logo at the foot.
 */
export function AuthLayout({ title, lead, children }: { title: string; lead?: ReactNode; children: ReactNode }) {
  useEffect(() => {
    document.title = `${title.replace(/[.?]$/, '')} · Pulsepoint`;
  }, [title]);
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', px: 2.5 }}>
      <Box component="main" sx={{ flex: 1, width: '100%', maxWidth: 420, mx: 'auto', pt: { xs: 8, md: 14 }, pb: 6 }}>
        <Box component="img" src={pulsepointLogo} alt="Pulsepoint" sx={{ width: 220, maxWidth: '100%', height: 'auto', display: 'block', mb: { xs: 6, md: 8 } }} />
        <Typography variant="h1" sx={{ mb: 1 }}>{title}</Typography>
        {lead && <Typography variant="subtitle1" component="div" sx={{ mb: 4 }}>{lead}</Typography>}
        {!lead && <Box sx={{ mb: 4 }} />}
        {children}
      </Box>
      <Box component="footer" sx={{ maxWidth: 420, width: '100%', mx: 'auto', pb: 4 }}>
        <Box component="img" src={logo} alt="Infinity EV" sx={{ width: 140, height: 'auto', display: 'block' }} />
      </Box>
    </Box>
  );
}
